import { Box, Link, Icon, Tooltip } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { FaWhatsapp } from 'react-icons/fa';

// Saffron to green soft glow animation
const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`;

const WhatsAppButton = () => {
  const phoneNumber = '919121287233';
  const message = 'Namaste Sri Renuka Ankammathalli Devasthanam, I would like to inquire about temple services and timings.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <Box
      position="fixed"
      bottom="80px"
      right="25px"
      zIndex={999}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Tooltip label="Chat on WhatsApp" placement="left" hasArrow bg="green.500" color="white" borderRadius="md" py={2} px={3}>
        <Link
          href={whatsappUrl}
          isExternal
          w="50px"
          h="50px"
          bg="#25D366"
          color="white"
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="0 4px 15px rgba(0, 0, 0, 0.2)"
          animation={`${pulse} 2s infinite`}
          _hover={{
            transform: 'scale(1.1) rotate(5deg)',
            bg: '#20ba5a',
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
          }}
          transition="all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          aria-label="Contact Temple on WhatsApp"
        >
          <Icon as={FaWhatsapp} boxSize={6} />
        </Link>
      </Tooltip>
    </Box>
  );
};

export default WhatsAppButton;
